export const RELATIONSHIPS = [
  'Spouse',
  'Father',
  'Mother',
  'Son',
  'Daughter',
  'Brother',
  'Sister',
  'Guardian',
  'Friend',
  'Relative',
  'Other',
];

export const RELATIONSHIP_OPTS = RELATIONSHIPS.map((r) => ({ value: r, label: r }));

export default RELATIONSHIP_OPTS;